export default {
  form: {
    owner_phone_number: {
      label: 'Yhteyshenkilön puhelinnumero',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Yhteyshenkilön sähköposti',
      placeholder: 'Anna sähköposti',
    },
    owner_first_name: {
      label: 'Etunimi',
      placeholder: 'Anna etunimi',
    },
    owner_last_name: {
      label: 'Sukunimi',
      placeholder: 'Anna sukunimi',
    },
    owner_dob: {
      label: 'Syntymäaika',
      placeholder: 'Päivämäärä',
    },
    owner_id_number: {
      label: 'Henkilötunnus (esim. sosiaaliturvatunnus Yhdysvalloissa)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
  },
};
